const API_BASE = 'https://3bxxzlknl8.execute-api.us-east-1.amazonaws.com/prod';

const FLUTTERWAVE_CONFIG = {
  publicKey: 'FLWPUBK-c4601a7cca5a57ef5d286b8f8510b8d5-X',
  isTest: false,
};

export const makePayment = async (userDetails, amount) => {
  const txRef = `PUMP_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;

  const paymentData = {
    public_key: FLUTTERWAVE_CONFIG.publicKey,
    tx_ref: txRef,
    amount: amount,
    currency: 'NGN',
    country: 'NG',
    payment_options: 'card,ussd,banktransfer',
    customer: {
      email: userDetails.email,
      phone_number: userDetails.phone,
      name: userDetails.name,
    },
    customizations: {
      title: 'PumpedPay',
      description: 'Wallet funding / ticket purchase',
      logo: 'https://pumpedng.org/logo.png',
    },
    meta: {
      user_id: userDetails.id,
    },
    callback_url: `${API_BASE}/api/webhooks/flutterwave`,
  };

  return new Promise((resolve, reject) => {
    window.FlutterwaveCheckout({
      ...paymentData,
      callback: async (response) => {
        if (response.status === 'successful') {
          const verified = await verifyPayment(response.transaction_id);
          resolve({
            success: true,
            transactionId: response.transaction_id,
            txRef: response.tx_ref,
            amount: response.amount,
            verified,
          });
        } else {
          reject({ success: false, message: response.status || 'Payment failed' });
        }
      },
      onclose: () => reject({ success: false, message: 'Payment window closed' }),
    });
  });
};

export const verifyPayment = async (transactionId) => {
  try {
    const response = await fetch(
      `${API_BASE}/api/payments/verify/${transactionId}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    );
    return await response.json();
  } catch (error) {
    console.error('Verification error:', error);
    return { status: 'error', message: error.message };
  }
};

console.log('✅ payment.js loaded - connected to AWS Lambda');